module.exports = __webpack_public_path__ + "img/logouts.82a4b4b0.svg";